import { ELkType } from '../../types/lkType';
import { TAppState } from '../../types/appState';

export const isSpecialistSelector = (state: TAppState) => {
  if (!state.lkType) {
    return false;
  }

  return state.lkType.lkType === ELkType.Specialist;
};
